import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { CommissionClickSellButton } from '@app/landings/store';

/**
 * When the user clicks on links on the footer.
 */
const events = getEvents((action: CommissionClickSellButton) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'sellCTA',
      position: action.payload.sell_cta_position,
      env_template: 'commission'
    }
  }
]);

export default events;
